import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Popconfirm,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import camera from '../../assets/images/icon/camera.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

const dateFormat = 'YYYY-MM-DD';
const storedFiles=[];
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			fees_details : [],
		}
		this.handleChange = this.handleChange.bind(this);	
	}

	componentWillMount() {
		if(document.querySelector(".loader-wrapper")){
			document.querySelector(".loader-wrapper").style = "display: none";
		}
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		var permission = storedArray['data'][0]['permission'];
		var type = storedArray['data'][0]['type'];
		//alert(type);
		this.setState({ user_id : storedArray['data'][0]['user_id'],id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'],user_type : type,permission : permission });
		this.checkData();
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 school_id : storedArray['data'][0]['school_id'], 
			 user_id : storedArray['data'][0]['user_id'], 
			 id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var id = this.props.match.params.id;
			var app = {user_id : user_id,id:id,school_id:school_id}
			getData('erp/fees_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							fees_details: result['data'],
						});	
					}else{
						this.setState({
							fees_details: [],
						});
					}
				}
			});				
	}
	}

	handleChange = ({ fileList }) => this.setState({ fileList });

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <img src={person} class="profile-img" />
        <img src={camera} class="profile-img-cam" />
      </div>
    );	
					
		return (
		<>
			
			<div class="mobile_view">
			<div class="row bred">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i>Details Fess Report
						
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/fees-report/success`} class="router-link-active" target="_self">Fees Report</a> </li>
							</ol>
						</div>
					</h4>
				</div>
				</div>
				</div>
			</div>
			
			<div id="main" class="bg-off">
         <div class="row">
	
			  {this.state.fees_details.map((list) => (
			<div class="col-md-12 ex-padd">
            
            <div class="view-Profile child-profile view-Profile-mobile">
			   <div class="col-md-12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children  bg-color-1 mb-20 bg-color-1 iq-card2 form-group">
						<div class="col-md-12">
						<div class="row">
							<div class="col-md-6">
								<div class="row">
									
									<div class="col-md-12">
										<label>Status  : <span class={list.color}><b>{list.payment_status}</b></span></label>
									</div>
									<div class="col-md-12">
										<label>Student Name : {list.name}</label>
									</div>
									<div class="col-md-12">
										<label>Class  : {list.class}</label>
									</div>
									<div class="col-md-12">
										<label>Academic Year  : {list.academic_year}</label>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="row">
									<div class="col-md-12">
										<label>Added Date  : {list.added_date}</label>
									</div>
									<div class="col-md-12">
										<label>Paid By  : {list.paid_by}</label>
									</div>
									<div class="col-md-12">
										<label>Traking Id  : {list.pay_tracking_id}</label>
									</div>
									<div class="col-md-12">
										<label>Total Amount  : {list.amount}</label>
									</div>
								</div>
							</div>
							
							<div class="col-md-12 mt-10">
								<div class="table-responsive">
									<table class="table table-striped table-bordered table-hover">
										<thead>
											<tr>
												<th>#</th>
												<th>Fees Type</th>
												<th>Amount</th>
											</tr>
										</thead>	
										<tbody>
											{list.fees_data.map((list,index) => (
											<tr>
												<td>{index+1}</td>
												<td>{list.type}</td>
												<td>{list.amount}</td>
											</tr>
											))}
										</tbody>
									</table>
								</div>	
							</div>
							
						</div> 
						</div> 
					</div> 
					
					<div class="col-md-12 meal mt-4 mb-20  text-center">
						 <Button className="btn btn-primary new-btn mr-2"  onClick={this.context.router.history.goBack}>Back</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			))}
         </div>
      </div>
     
			</div>
		</>	
		) 
	} 
}
export default Index;
